export default function IconArrow() {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className="comp-item-icon">
            <g clipPath="url(#clip0_1793_53950)">
                <path d="M18.5 14.5L12.5 8.5L6.5 14.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1793_53950">
                    <rect width="24" height="24" fill="white" transform="matrix(1 0 0 -1 0.5 24.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
